// @flow
import type { ModalType } from "./types"

type NotNeeded = {|
  close: Function,
|}

export const openModal = <T>(
  type: ModalType<T>,
  // $ExpectError
  data: $Diff<T, NotNeeded>,
) => ({
  type: "MODALS/OPEN_MODAL",
  payload: { type, data },
})

export const closeModal = () => ({
  type: "MODALS/CLOSE_MODAL",
})



// WEBPACK FOOTER //
// ./src/data/modals/actions.js